import { Box, Grid, GridColumn, Target } from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, HeaderContent } from "@/content-V2/types";

export const Header: React.FC<ContentComponentProps<HeaderContent>> = ({
  href,
  localeSelector,
  logo
}) => {
  return (
    <Box
      as="header"
      sx={{
        backgroundColor: "surface-neutral",
        flex: 0
      }}
    >
      <Grid variant="uniform-12">
        <GridColumn>
          <Box
            sx={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <Target {...(href && { href: href })} sx={{ display: "block", py: 4 }}>
              {logo}
            </Target>
            {localeSelector && <Box sx={{ marginInlineStart: "auto" }}>{localeSelector}</Box>}
          </Box>
        </GridColumn>
      </Grid>
    </Box>
  );
};
